import { Injectable } from '@angular/core';
import { IThemeConfig } from './theme.interface';

@Injectable({
  providedIn: 'root'
})
export abstract class ThemeConfig implements IThemeConfig {
  abstract readonly themeRoot: string;
  abstract readonly themeSource: string;
  abstract readonly themeFileId: string;
  abstract readonly themeName: string;
  abstract readonly themeSuffix: string;
  abstract readonly themeIconSet: string;

  constructor() {}
}
